// src/redux/store/features.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AppLocale } from '@/i18n/localeConfig';

interface FeaturesState {
  sidebarOpen: boolean;
  language: AppLocale;
  theme: 'light' | 'dark';
  dynamic: Record<string, any>;
  loading: boolean;
}

const initialState: FeaturesState = {
  sidebarOpen: false,
  language: 'en',
  theme: 'light',
  dynamic: {},
  loading: false,
};

const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    closeSidebar: (state) => {
      state.sidebarOpen = false;
    },
    setLanguage: (state, action: PayloadAction<AppLocale>) => {
      state.language = action.payload;
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload;
    },
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light';
    },
    setDynamicState: (state, action: PayloadAction<{ key: string; value: any }>) => {
      state.dynamic[action.payload.key] = action.payload.value;
    },
    toggleLoading: (state) => {
      state.loading = !state.loading;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  toggleSidebar,
  closeSidebar,
  setLanguage,
  setTheme,
  toggleTheme,
  setDynamicState,
  setLoading,
} = featuresSlice.actions;

export default featuresSlice.reducer;
